<template>
  <div
    class="tag-anchor"
    :style="styles" @click="revealTag">
    <div class="tag-anchor__pos">
      <div
        class="tag-reveal"
        :class="classes"
      >
        <div class="tag-reveal__inner">
          <div
            v-if="label"
            class="tag-reveal__content-col"
            :class="{ 'dir-rtl' : language.rtl }"
          >
            <div
              class="tag-reveal__label"
              v-html="label[language.code]"
            />
            <div
              class="tag-reveal__description"
              :class="{ 'reveal' : isActive }"
              v-html="description[language.code]"
            />
          </div>
          <div class="tag-reveal__image-col" v-if="asset && asset.type === 'image'">
            <div class="tag-reveal__image-clip">
              <img class="tag-reveal__asset" :src="`${$store.state.assetsPath}${asset.path}`"> 
            </div>
          </div>
          <div class="tag-reveal__image-col" v-if="asset && asset.type === 'video'">
            <div class="tag-reveal__image-clip">
              <video
                class="tag-reveal__asset"
                :class="{ 'reveal' : isActive }"
                :src="`${$store.state.assetsPath + asset.path}`"
                autoplay
                muted
                loop
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['pos', 'overlay-content', 'label', 'description', 'asset', 'active'],

  data () {
    return {
      isActive: false,
      wooshCloseSound: null,
      wooshOpenSound: null
    }
  },

  watch: {
    active () {
      if (this.active) {
        this.wooshOpenSound.pause()
        this.wooshOpenSound.currentTime = 0
        this.wooshOpenSound.play()
      } else {
        this.wooshCloseSound.pause()
        this.wooshCloseSound.currentTime = 0
        this.wooshCloseSound.play()        
      }
    }
  },

  computed: {
    classes () {
      let classes = {}
      classes['reveal'] = this.isActive
      return classes
    },

    language () {
      return this.$store.getters.language
    },

    styles () {
      return {
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
      }
    }
  },

  mounted () {
    this.wooshCloseSound = new Audio('/assets/sounds/woosh_close.mp3')
    this.wooshOpenSound = new Audio('/assets/sounds/woosh_open.mp3')
  },

  methods: {
    revealTag () {
      this.isActive = !this.isActive
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";

$tag-tail-length: 8em;

.tag-anchor {
  font-size: 1em;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transform: translateY(0);
  transition: opacity 1.2s, transform 0.6s;
  z-index: 15;

  &.enter {
    opacity: 1;
    transform: translateY(0);
  }

  &__pos {
    color: $rich-tag-bg-color;
    height: 0;
    width: 0;
  }
}

.tag-reveal {
  background-color: transparent;
  color: $rich-tag-font-color;
  font-size: $rich-tag-font-size;
  height: 4.5em;
  letter-spacing: .05em;
  line-height: 1.2em;
  overflow: visible;
  pointer-events: none;
  position: absolute;
  transition: all 350ms ease-in-out 350ms;
  width: 18em;
  z-index: 5;

  &.reveal {
    transition: all 350ms ease-in-out;
    height: 15em;
  }

  * {
    pointer-events: none;
    user-select: none;
  }

  &__inner {
    display: flex;
    height: 100%;
    position: absolute;
    transition: transform 300ms, opacity 300ms;
    width: 36em;
  }

  &__image-col {
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    height: 100%;
    left: 0;
    top: 0;
    width: 50%;
    filter: drop-shadow($tag-box-shadow);
    overflow: hidden;
    pointer-events: auto;
    transform: translateX(-3%);
  }

  &__image-clip {
    clip-path: polygon(100% 0%, 100% 50%, 100% 100%, 0% 100%, 2% 99%, 2.5% 98%, 3% 97%, 3% 50%, 3% 3%, 2.5% 2%, 2% 1%, 0% 0%);
    height: 100%;
  }

  &__image {
    height: 100%;
    transform: translateX(-100%);
    width: 100%;
    object-fit: cover;
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  &__video {
    height: 100%;
    transform: translateX(-100%);
    width: 100%;
    object-fit: cover;
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  &__asset {
    height: 100%;
    transform: translateX(-100%);
    transition: transform 350ms ease-in-out 0ms;
    width: 100%;
    object-fit: cover;
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;

    &.reveal {
      transition: transform 350ms ease-in-out 350ms;
      transform: translateX(0);
    }
  }

  &__content-col {
    background: $rich-tag-bg-color;
    border-radius: $rich-tag-border-radius;
    box-shadow: $tag-box-shadow;
    height: 100%;
    overflow: hidden;
    padding: 1.5em;
    pointer-events: auto;
    position: relative;
    width: 50%;
    z-index: 2;
  }

  &__label {
    font-size: 1.3em;
    font-weight: 300;
    line-height: 1.2em;
    margin-bottom: .6em;
    margin-top: .1em;
    text-align: left;
    -webkit-font-smoothing: auto;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;


    .reveal & {
      white-space: initial;
    }
  }

  &__description {
    font-size: 0.75em;
    font-weight: 200;
    line-height: 1.4;
    opacity: 0;
    transition: opacity 350ms ease-in-out 350ms;

    &.reveal {
      transition: opacity 350ms ease-in-out;
      opacity: 1;
    }
  }
}
</style>
